import React from 'react'
import Link from 'gatsby-link'
import classNames from 'classnames'

import logo_header from '../../images/logo-header.png'


const Header = ({ location }) => (
    <div
        className={classNames(
            'navbar',
            'navbar-dark',
            'navbar-expand-lg',
            { 'bg-transparent': location.pathname === '/' }
        )}
        role="banner"
    >
        <div className="container"> {/* default class with bg-transparent: no-override */ }
            <Link className="navbar-brand" to="/">
                { location.pathname !== '/' && <img src={ logo_header } /> }
                { location.pathname === '/' && 'Dismocan' }
            </Link>

            <button className="navbar-toggler" data-toggle="collapse" data-target="#navbar-collapse">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse justify-content-end" id="navbar-collapse">
                <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                        <Link to="/" className="nav-link">
                            Inicio
                        </Link>
                    </li>
                </ul>
                <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" style={{ cursor: 'pointer '}}>
                            Soluciones técnicas
                            <i className="ion-chevron-down"></i>
                        </a>
                        <div className="dropdown-menu">
                            <Link className="dropdown-item" to="/soluciones-tecnicas/humedades">Humedades</Link>
                            <Link className="dropdown-item" to="/soluciones-tecnicas/morteros-tecnicos">Morteros técnicos</Link>
                            <Link className="dropdown-item" to="/soluciones-tecnicas/decoracion">Decoración</Link>
                            <Link className="dropdown-item" to="/soluciones-tecnicas/pintura">Pintura</Link>
                        </div>
                    </li>
                </ul>
                <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                        <Link to="/quienes-somos" className="nav-link">
                            Quienes somos
                        </Link>
                    </li>
                </ul>
                <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                        <Link to="/contacto" className="nav-link">
                            Contacto
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/layouts/Header/index.js